/**
 * Round Interstitial — Shows round number, name, rules.
 * Auto-advances after countdown or player skips.
 */

import { getState, startTurnWaiting } from '../game-state';
import { RoundNumber } from '../../shared/types';
import { navigate } from '../router';
import { t, getRoundName, getRoundDesc } from '../i18n';

let countdownInterval: number | null = null;
let countdown = 10;

export function renderRoundInterstitial(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const round = state.currentRound;

  countdown = 10;
  clearCountdown();

  app.innerHTML = `
    <div class="round-interstitial">
      <div class="round-number">${t('roundN', round)}</div>
      <div class="round-name">"${getRoundName(round)}"</div>
      <div class="round-description">${getRoundDesc(round)}</div>

      <div class="stack">
        <button class="btn btn-primary" id="btn-skip">${t('letsGo')}</button>
        <p class="text-muted" id="countdown-text" style="font-size: var(--font-size-sm);">
          ${t('startingIn', countdown)}
        </p>
      </div>
    </div>
  `;

  // Countdown
  countdownInterval = window.setInterval(() => {
    countdown--;
    const el = document.getElementById('countdown-text');
    if (el) el.textContent = t('startingIn', countdown);
    if (countdown <= 0) {
      advance();
    }
  }, 1000);

  // Skip button
  document.getElementById('btn-skip')?.addEventListener('click', advance);
}

function advance(): void {
  clearCountdown();
  startTurnWaiting();
  navigate('turn-waiting');
}

function clearCountdown(): void {
  if (countdownInterval !== null) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }
}
